import { ROUTES } from "@repo/core/routes";
import { Welcome } from "@repo/core/screens/Login/Welcome";
import useAuthStore from "@repo/core/stores/auth";
import {
  ViewableContent,
  useViewedContentStore,
} from "@repo/core/stores/viewedContent";
import { Navigate } from "react-router-dom";

export const WebWelcome = () => {
  // Hooks & State
  const { user } = useAuthStore();
  const { hasViewedContent } = useViewedContentStore();

  if (hasViewedContent(ViewableContent.APP_WELCOME, user?.username!)) {
    return <Navigate to={ROUTES.home} />;
  }

  // Wrap the Welcome screen with the Web redirects
  return <Welcome />;
};
